import React from 'react';
import PropTypes from 'prop-types';
import { motion } from "framer-motion";
import TitleBoxComponent from './TitleBoxComponent';
import PageLoadingComponent from '../utils/PageLoadingComponent';

const FormBoxComponent = ({
  style, titleName, iconName, homeLink,
  handleSearchText,
  searchHandleNavigate,
  handleKeyPress,
  handleClickAddAction,
  handleClickFilterAction,
  hidden = false,
  children,
  isLoading }) => {
  if (hidden) return null;

  return (
    <>
      <PageLoadingComponent isLoading={isLoading} />
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        className={`p-6 bg-white shadow-xl rounded-2xl max-w-md mx-auto ${style}`}>
        <div className="mb-4">
          <TitleBoxComponent
            titleName={titleName}
            iconName={iconName}
            homeLink={homeLink}
            handleSearchText={handleSearchText}
            searchHandleNavigate={searchHandleNavigate}
            handleKeyPress={handleKeyPress}
            handleClickAddAction={handleClickAddAction}
            handleClickFilterAction={handleClickFilterAction}
          />
          <div className="col-md-12 p-1">
            {children}
          </div>
        </div>
      </motion.div>
    </>
  );
};

FormBoxComponent.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  style: PropTypes.string,
  titleName: PropTypes.string,
  iconName: PropTypes.string,
  homeLink: PropTypes.string,
  handleSearchText: PropTypes.func,
  searchHandleNavigate: PropTypes.func,
  handleKeyPress: PropTypes.func,
  handleClickAddAction: PropTypes.func,
  handleClickFilterAction: PropTypes.func,
  hidden: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

FormBoxComponent.defaultProps = {
  titleName: '',
  iconName: '',
  hidden: false,
  isLoading: false,
};

export default FormBoxComponent;
